<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from 'axios';
import Tickets from "../../../mixins/Tickets";
import ReportingInterfaceWrapper from "../reporting/show/ReportingInterfaceWrapper";
import ReportingMainSection from "../reporting/show/ReportingMainSection";
import ReportingMainSectionLeftColumn from "../reporting/show/ReportingMainSectionLeftColumn";
import ReportingMainSectionSidebar from "../reporting/show/ReportingMainSectionSidebar";
import {mapGetters, mapActions} from "vuex";
import AutomatedReportToolbar from '../reporting/show/AutomatedReportToolbar.vue';

/**
 * Reporting-view component
 */
export default {
  page: {
    title: "Automated Report Result",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Tickets],
  components: {
    ReportingInterfaceWrapper,
    Layout,
    PageHeader,
    ReportingMainSection,
    ReportingMainSectionLeftColumn,
    ReportingMainSectionSidebar,
    AutomatedReportToolbar
  },
  computed: {},
  data() {
    return {
      title: "Edit Report",
      items: [
        {
          text: "Automated Reporting",
          href: "/automated-reporting"
        },
        {
          text: "View Report",
          active: true
        }
      ],
      automatedReportResult: null,
      isLoading: false
    };
  },
  mounted() {
  },
  watch: {
    $route(newRoute) {
      this.refreshRoute();
    }
  },
  created() {
    this.loadAgents();
    this.refreshRoute();
  },
  methods: {
    ...mapActions('reportEditor', {
      loadAgents: 'loadAgents',
      setAutomatedReportResults: 'setAutomatedReportResults'
    }),

    loadAutomatedReport() {
      let vm = this;
      vm.isLoading = true;
      axios.get(window.API_BASE + '/automated-report-results/' + vm.$route.params.id)
        .then(function (response) {
          vm.automatedReportResult = response.data;
          vm.isLoading = false;
          vm.setAutomatedReportResults(response.data);
        })
        .catch(function (error) {
          vm.isLoading = false;
          console.log(error);
          vm.$notify.error({title: "Report not found"});
          vm.$router.push('/automated-reporting');
        });
    },

    refreshRoute() {
      if (this.$route.params.id) {
        this.loadAutomatedReport(this.$route.params.id);
      } else {
        this.$router.push('/automated-reporting'); 
      }
    }
  }
};
</script>

<template>
  <Layout :full-width="true">
    <loading-screen :is-loading="isLoading"></loading-screen>
    <ReportingInterfaceWrapper v-if="automatedReportResult">
      <!-- <ReportingToolbar></ReportingToolbar> -->
      <AutomatedReportToolbar :automated-report-result="automatedReportResult"></AutomatedReportToolbar>
      <ReportingMainSection>
        <ReportingMainSectionLeftColumn></ReportingMainSectionLeftColumn>
        <!-- <ReportingMainSectionSidebar></ReportingMainSectionSidebar> -->
      </ReportingMainSection>
    </ReportingInterfaceWrapper>
  </Layout>
</template>

<style scoped></style>